import { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SecondaryButtonProps } from '@organisms/SecondaryButton'

type Props = {
  newRoute?: string | null
  onChangePage: () => Promise<void>
  ButtonComponent: FC<SecondaryButtonProps>
  id?: string
  isTestBlocked?: boolean
  onBlockedNavigation?: (pendingNavigation?: () => void) => void
  isPreviewMode?: boolean
}

const ChangeThemeButton: FC<Props> = ({
  newRoute,
  onChangePage,
  ButtonComponent,
  id,
  isTestBlocked,
  onBlockedNavigation,
  isPreviewMode,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const locationState = location.state as { returnTo?: string } | undefined
  const returnTo = locationState?.returnTo

  const handleClick = async () => {
    if (!newRoute) return

    const goToRoute = () => {
      navigate(
        newRoute,
        isPreviewMode
          ? { state: { isPreviewMode: true, ...(returnTo ? { returnTo } : {}) } }
          : undefined
      )
    }

    if (isTestBlocked) {
      // Не выбрасываем переход: отдаём его наверх, чтобы выполнить после того,
      // как пользователь пройдёт контрольный вопрос. onChangePage (пауза) здесь
      // не нужен — тема будет пройдена, а её размонтирование отработает статистику.
      onBlockedNavigation?.(goToRoute)
      return
    }

    await onChangePage()
    goToRoute()
  }

  if (!newRoute) return null

  return <ButtonComponent onClick={handleClick} id={id} />
}
export default ChangeThemeButton
